import { render, staticRenderFns } from "./MegaMenu.vue?vue&type=template&id=18968496&scoped=true&"
import script from "./MegaMenu.vue?vue&type=script&lang=ts&"
export * from "./MegaMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MegaMenu.vue?vue&type=style&index=0&id=18968496&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18968496",
  null
  
)

export default component.exports